module.exports = __webpack_public_path__ + "static/media/icon-disable-askIa.b311a5d2.svg";